import { VersioningSection } from '@/accessControl/VersioningSection.molecule';
import { Checkbox } from '@/core/Checkbox.atom';
import type { VersionState } from '@/core/hooks/useVersionState.hook';

type LockingSectionProps = {
  versionState: VersionState;
  disabled?: boolean;
  showVersioningSection?: boolean;
  checkboxId: string;
  checkboxLabel: string;
  isChecked: boolean;
  onCheckChange: (checked: boolean) => void;
};

export const LockingSection = ({
  versionState,
  disabled,
  showVersioningSection = true,
  checkboxId,
  checkboxLabel,
  isChecked,
  onCheckChange,
}: LockingSectionProps) => (
  <>
    {showVersioningSection && <VersioningSection versionState={versionState} disabled={disabled} />}
    <div className="tw:mt-sq-10">
      <Checkbox
        id={checkboxId}
        isChecked={isChecked}
        onChange={() => onCheckChange(!isChecked)}
        label={checkboxLabel}
      />
    </div>
  </>
);
